import { Autocomplete, Box, Button, createMuiTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { GuardarNuevoActivo, GuardarNuevoTipoActivo, ObtenerTiposActivo } from '../../helpers/ActivosHelper';
import { ObtenerCapitulos } from '../../helpers/CapitulosHelper';
import { ActivosContext } from '../../pages/catalogos/ActivosPage';
import { TiposActivoContext } from '../../pages/catalogos/ActivosTipoPage';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalAgregaActivoComponent = () => {
    const {instalacionEditando, setInstalacionEditando, instalacionSeleccionada, modalAgregaActivo, setModalAgregaActivo, obtenerTipos, activoSeleccionado, editandoInstalacion, setEditandoInstalacion, setActivoSeleccionado} = useContext(ActivosContext);
    const [tipoActivo, setTipoActivo] = useState();
    const [tiposActivo, setTiposActivo] = useState({});
    const [capitulos, setCapitulos] = useState({});
    const [errorGuardado, setErrorGuardado] = useState(false);
    const [datosActivo, setDatosActivo] = useState({idPadre:activoSeleccionado?.key});
    const [index, setIndex] = useState(-1);
    const refForm = useRef();
    console.log('Valor de modal agrega', modalAgregaActivo, activoSeleccionado, datosActivo);

    const handleClose = () => {
      setDatosActivo({});
        setModalAgregaActivo(false);
        setEditandoInstalacion();
    }

    useEffect(() => {
      if(editandoInstalacion) {
        console.log('editando instalacion', editandoInstalacion, instalacionEditando );
        console.log('tiposActivo', tiposActivo);
        console.log('instalacioneditando', instalacionEditando);
        const index1 = tiposActivo.findIndex(tipoActivo => tipoActivo.id==instalacionEditando.IdTipoInstalacion);
        setIndex(index1);
        console.log('index de tipo activo1', index)
        setDatosActivo(
          {
            'idInstalacion':instalacionEditando.IdInstalacion,
            'idTipoInstalacion':instalacionEditando.IdTipoInstalacion, 
            'descripcion':instalacionEditando.Descripcion,
            'siglas':instalacionEditando.Siglas,
            'marca':instalacionEditando.Marca,
            'modelo':instalacionEditando.Modelo,
            'serie':instalacionEditando.NumeroSerie,
            'numeroInventario':instalacionEditando.NumeroInventario,
            'idPadre':instalacionEditando.IdInstalacionPadre
          }
        )
      }
    }, [editandoInstalacion, instalacionEditando])
    

    const handleSubmit =  async(event) => {
        await actualizaDatos('idPadre', activoSeleccionado?.key);
        event.preventDefault();
        //refForm.current.isValidate();
        GuardarNuevoActivo(datosActivo).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
//                obtenerTipos();
                handleClose();

            }
        })
    }

    useEffect(() => {
     // actualizaDatos('idPadre', activoSeleccionado?.key);
      setDatosActivo({idPadre:activoSeleccionado?.key});
    }, [activoSeleccionado])
    
    useEffect(() => {
      console.log('cambio datos activo', datosActivo)
    }, [datosActivo, index])
    

    const actualizaDatos = (dato, valor) => {
      setDatosActivo({
          ...datosActivo,
          [dato]:valor
      })
    }

    const obtenerTiposActivo = async() => {
      await ObtenerTiposActivo().then(datos=> {
        const opciones = new Array();
          datos?.map(dato => {
            opciones.push({...tiposActivo,label:dato.TipoInstalacion, id:dato.IdTipoInstalacion})
          })

          setTiposActivo(opciones);
        })
    }

    const obtenerCapitulos = () => {
      ObtenerCapitulos().then(response => {
        const opciones = new Array();
        response?.map(dato => {
          opciones.push({...capitulos,label:dato.descripcion, id:dato.idCapitulo})
        })

        setCapitulos(opciones);
      })
    }

    // useEffect(() => {
    //   console.log('datos activo', datosActivo);
    // }, [datosActivo])

    useEffect(() => {
      actualizaDatos('idPadre', activoSeleccionado?.key);
      obtenerTiposActivo();
      obtenerCapitulos();
       // setTiposActivo(datos)})      
    }, [])

  return (
      <div
        style={{
         //   minWidth:600, minHeight:800
        }}
    >
     <Dialog open={modalAgregaActivo} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>
          <Typography
            style={{
              fontSize:'1.25rem',
              fontWeight:'500'
            }}
          >
            Agregar Instalación
          </Typography>
          <Typography>
            Pertenecerá a la instalación "{activoSeleccionado?.title}"
          </Typography>
        </DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          <Autocomplete
            variant="standard"
            onChange={(event, newValue) => {console.log('new value', newValue); actualizaDatos('idTipoInstalacion', newValue)}}
            value={tiposActivo[index] || datosActivo?.idTipoInstalacion?.id}
            //defaultValue={tiposActivo[index]}
            //disablePortal
            id="combo-box-demo"
            options={tiposActivo}
            sx={{ width: '100%', zIndex:999999999 }}
            style={{zIndex:99999999}}
            renderInput={(params) => <TextField variant="standard"  autoFocus style={{zIndex:9999999, backgroundColor:'white', marginTop:5}} {...params} label="Tipo de Instalación" />}
          />
          <Autocomplete
            variant="standard"
            onChange={(event, newValue) => {console.log('new value', newValue); actualizaDatos('idCapitulo', newValue)}}
            value={capitulos[index] || datosActivo?.idCapitulo?.id}
            //defaultValue={tiposActivo[index]}
            disablePortal
            id="combo-box-demo"
            options={capitulos}
            sx={{ width: '100%', zIndex:999999 }}
            style={{zIndex:99999}}
            renderInput={(params) => <TextField variant="standard"  autoFocus style={{zIndex:999999, backgroundColor:'white', marginTop:5}} {...params} label="Capítulo" />}
          />
          <TextField
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="Siglas"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaDatos('siglas', e.target.value)}
            value={datosActivo?.siglas}
          />

          <TextField
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="Descricipción de la instalación"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaDatos('descripcion', e.target.value)}
            value={datosActivo?.descripcion}
          />
          <TextField
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="Marca"
            type="text"
            fullWidth
            variant="standard"
            required={false}
            onChange={(e) => actualizaDatos('marca', e.target.value)}
            value={datosActivo?.marca}
          />
          <TextField
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="Modelo"
            type="text"
            fullWidth
            variant="standard"
            required={false}
            onChange={(e) => actualizaDatos('modelo', e.target.value)}
            value={datosActivo?.modelo}
          />
          <TextField
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="# de Serie"
            type="text"
            fullWidth
            variant="standard"
            required={false}
            onChange={(e) => actualizaDatos('serie', e.target.value)}
            value={datosActivo?.serie}
          />
          <TextField
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="# de Inventario"
            type="text"
            fullWidth
            variant="standard"
            required={false}
            onChange={(e) => actualizaDatos('numeroInventario', e.target.value)}
            value={datosActivo?.numeroInventario}
          />
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Guardar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
